// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import YoutubeFilledSvg from "@ant-design/icons-svg/es/asn/YoutubeFilled";
import AntdIcon from '../components/AntdIcon';

var YoutubeFilled = function YoutubeFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: YoutubeFilledSvg
  }));
};

YoutubeFilled.displayName = 'YoutubeFilled';
export default React.forwardRef(YoutubeFilled);